export type NotificationState = {
    title: string | null;
    message: string | null;
    dataDisplay?: string | null;
    dataRaw?: string | null;
    callback?: Function | null;
    showCancel?: boolean;
    submitLabel?: string;
};

export enum NotificationActionType {
    SHOW_NOTIFICATION = 'SHOW_NOTIFICATION',
    REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION'
}

export type NotificationAction = ShowNotification | RemoveNotification;

export type ShowNotification = {
    type: NotificationActionType.SHOW_NOTIFICATION;
    payload: NotificationState;
};
export type RemoveNotification = {
    type: NotificationActionType.REMOVE_NOTIFICATION;
};

export const notificationInitialState: NotificationState | undefined = undefined;

export const notificationReducer = (state = notificationInitialState, action: NotificationAction) => {
    switch (action.type) {
        case NotificationActionType.SHOW_NOTIFICATION:
            return action.payload;
        case NotificationActionType.REMOVE_NOTIFICATION:
            return notificationInitialState;
        default:
            return state;
    }
};
